import { UPLOAD_COD_REMITTANCE_REQUEST, UPLOAD_COD_REMITTANCE_SUCCESS, UPLOAD_COD_REMITTANCE_FAILURE, } from "../../actions";
const initialState = {
    uploading: false,
    success: false,
    error: null,
    data: null,
};
const codRemittancefileUploadReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPLOAD_COD_REMITTANCE_REQUEST:
            return Object.assign(Object.assign({}, state), { uploading: true, success: false, error: null });
        case UPLOAD_COD_REMITTANCE_SUCCESS:
            return Object.assign(Object.assign({}, state), { uploading: false, success: true, error: null, data: action.payload });
        case UPLOAD_COD_REMITTANCE_FAILURE:
            return Object.assign(Object.assign({}, state), { uploading: false, success: false, error: action.payload });
        default:
            return state;
    }
};
export default codRemittancefileUploadReducer;
